export const STEP_HOSE = 'texts.step1.tabName';
export const STEP_FITTING = 'texts.step2.tabName';
export const STEP_ASS_LENGTH = 'texts.step3.tabName';
export const STEP_ANGLE = 'texts.step4.tabName';
export const STEP_ACCESSORIES = 'texts.step5.tabName';
export const STEP_CONFIRM = 'texts.step6.tabName';
